import { useState, useCallback } from 'react';
export function useLocalStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch {
            return initialValue;
        }
    });
    const setValue = useCallback((value) => {
        try {
            setStoredValue((prev) => {
                const next = typeof value === 'function' ? value(prev) : value;
                localStorage.setItem(key, JSON.stringify(next));
                return next;
            });
        }
        catch {
            // storage full or private mode
        }
    }, [key]);
    const removeValue = useCallback(() => {
        try {
            localStorage.removeItem(key);
            setStoredValue(initialValue);
        }
        catch {
            // ignore
        }
    }, [key, initialValue]);
    return [storedValue, setValue, removeValue];
}
//# sourceMappingURL=useLocalStorage.js.map